import { observer } from 'mobx-react-lite';
import { gameStore, roundTimeStore } from '../../../store';
import { ReportOdd } from '../../../components/common/gamePart/reportsOdd';
import { GearAnimation } from '../../../components/common/gamePart/gearAnimation';
import { CurrentWinAmount } from './currentWinAmount';
import { DoBet } from './doBet';
import { animationStore } from '../../../store/animationStore';
import { GameClosBtn } from '../../../components/common/gamePart/gameCloseBtn';

export const GamePart = observer(({ gameTypeId }) => {
  const { setActiveGameType, activeGameType } = gameStore;
  const { isFinishTimeByGameType } = roundTimeStore;
  const { isGameClosedByGameType } = animationStore;

  return (
    <div
      className={`pascal-game-ins-col  
       ${isGameClosedByGameType[gameTypeId] ? 'passive' : ''}
       ${activeGameType === gameTypeId ? 'active' : ''}
       ${isFinishTimeByGameType[gameTypeId] || isGameClosedByGameType[gameTypeId] ? '' : 'open'}
      `}
      onClick={() => {
        setActiveGameType(gameTypeId);
      }}
    >
      <GameClosBtn gameTypeId={gameTypeId} />
      <ReportOdd gameTypeId={gameTypeId} />
      <GearAnimation gameTypeId={gameTypeId} />
      <div className='pascal-game-col-bottom'>
        <CurrentWinAmount gameTypeId={gameTypeId} />
        <DoBet gameTypeId={gameTypeId} />
      </div>
    </div>
  );
});
